import "./HeroImgStyle.css"
import IntroBg from "../assests/IntoBg.jpg"

import React from 'react'
import { Link } from "react-router-dom"

function HeroImg() {
  return (
    <div className="hero">
        <div className="mask">
            <img className="intro-img" src={IntroBg} alt="IntroBg" />

        </div>
        <div className="content">
            <p>HI, I'M AYAN SRIVASTAVA</p>
            <h1>FRONT END DEVELOPER</h1>
            <div>
                <Link to="/Project" className="btn">Projects</Link>
                <Link to="/Contact" className="btn btn-light">Contact</Link>
            </div>
        </div>
    </div>
  )
};

export default HeroImg